import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ProgramsHero } from '../components/programs/ProgramsHero';
import { ProgramsGrid } from '../components/programs/ProgramsGrid';
import { CTASection } from '../components/home/CTASection';
export function ProgramsPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-1224">
      <Header data-id="element-1225" />

      <main className="pt-20" data-id="element-1226">
        <ProgramsHero data-id="element-1227" />
        <ProgramsGrid data-id="element-1228" />
        <CTASection data-id="element-1229" />
      </main>

      <Footer data-id="element-1230" />
    </div>;
}